import axios from '../../helpers/axios-setup';
import { TCAutocomplete } from '../../components/pages/test-case/types';

export const testCaseAutoComplete = (queryString: string) =>
  axios.get<TCAutocomplete[]>(`/test-cases/autocomplete?text=${queryString}`);
